module.exports = __webpack_public_path__ + "media/images/views/lp/recruiter/join/step-screen-4-efc152722e1d76d596bf6453c1b25f0d.png";